import { useState } from "react";
import { Loader2, X } from "lucide-react";
import { api } from "@/lib/api";

const TIPS = [
  "Pick the portal card that matches your account. Franchisees and admins use Franchisee Login.",
  "Use the exact email ALR set up for you, or Continue with Google if your Google account uses that same email.",
  "If you see \"Please contact ALR\", your account is paused. Email info@alrclean.com.",
];

export const CantLoginDialog = ({ open, onClose, accent, initialEmail }) => {
  const [email, setEmail] = useState(initialEmail || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  if (!open) return null;
  const send = async () => {
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) return setError("Please enter a valid email address.");
    setBusy(true); setError(null);
    try { await api("/auth/forgot-password", { method: "POST", auth: false, body: { email: email.trim() } }); setSent(true); }
    catch (err) { setError(err.message || "Couldn't send the link. Please try again."); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/80 p-6" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="relative w-full max-w-md rounded-2xl border border-[#333] bg-[#1A1A1A] p-7 text-white" data-testid="cant-login-dialog">
        <button type="button" onClick={onClose} aria-label="Close" data-testid="cant-login-close" className="absolute right-4 top-4 text-neutral-400 hover:text-white"><X size={20} /></button>
        <p className="text-[11px] font-bold tracking-[3px]" style={{ color: accent }}>CAN'T LOG IN?</p>
        <h2 className="mt-1 text-xl font-extrabold">Get a fresh setup link</h2>
        {sent ? (
          <p className="mt-4 text-[14px] leading-6 text-neutral-300" data-testid="cant-login-sent">If an account uses <b className="text-white">{email.trim()}</b>, we've emailed a one-time link to set a new password. It works for 24 hours. Check your spam folder if it doesn't arrive in a few minutes.</p>
        ) : (
          <>
            <ul className="mt-4 space-y-2 text-[13px] leading-5 text-neutral-300">{TIPS.map((t) => <li key={t} className="flex gap-2"><span style={{ color: accent }}>•</span>{t}</li>)}</ul>
            <label className="mt-5 block">
              <span className="mb-1.5 block text-[11px] font-bold tracking-[2px]" style={{ color: accent }}>YOUR ACCOUNT EMAIL</span>
              <input data-testid="cant-login-email" type="email" value={email} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); send(); } }} onChange={(e) => setEmail(e.target.value)} placeholder="you@alrclean.com"
                className="w-full rounded-lg border border-[#333] bg-[#121212] px-4 py-3.5 text-[15px] text-white outline-none placeholder:text-neutral-500 focus:border-[var(--accent)]" style={{ "--accent": accent }} />
            </label>
            {error && <p className="mt-2 text-[13px] text-[#FF3333]" data-testid="cant-login-error">{error}</p>}
            <button type="button" onClick={send} disabled={busy} data-testid="cant-login-submit" className="mt-5 flex w-full items-center justify-center rounded-lg py-4 text-[13px] font-extrabold tracking-[1.6px] text-black disabled:opacity-60" style={{ background: accent }}>
              {busy ? <Loader2 className="animate-spin" size={18} /> : "EMAIL ME A SETUP LINK"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
